import { createRouter, createWebHistory } from 'vue-router'
import Admin from '../views/Admin.vue'
import Branches from '@/components/page/Branches.vue'
import Employees from '@/components/page/Employees.vue'
import store from '@/components/store/store'
import ContactsList from '@/components/page/ContactsList.vue'
import CertificatesList from '@/components/page/CertificatesList.vue'
import ClientPayments from '@/components/page/Payments.vue'
import Calendar from '@/components/page/Calendar.vue'
import Services from '@/components/page/Services.vue'
import CustomFields from '@/components/page/CustomFields.vue'
import RegisterBlock from '@/components/RegisterBlock.vue'
import Dialogs from '@/components/page/Dialogs.vue'
import DialogSettings from '@/components/page/DialogSettings.vue'
import Settings from '@/components/page/Settings.vue'
import SchedulerPage from '@/components/page/SchedulerPage.vue'
import ForgotPassword from '@/components/ForgotPassword.vue'
import ResetPassword from '@/components/ResetPassword.vue'
import { permissionGroups, routeAccessMap } from '@/components/util/accessHelper'
import Billing from '@/components/views/setting/Billing.vue'
import BillingSuccess from '@/components/views/setting/BillingSuccess.vue'
import BillingFail from '@/components/views/setting/BillingFail.vue'
import { getCookieValue } from '@/components/util/cookies'


const routes = [
  {
    path: '/',
    name: 'Calendar',
    component: Calendar
  },
  {
    path: '/branches',
    name: 'Branches',
    component: Branches
  },
  {
    path: '/services',
    name: 'Services',
    component: Services
  },
  {
    path: '/contacts',
    name: 'ContactsList',
    component: ContactsList
  },
  {
    path: '/certificates',
    name: 'CertificatesList',
    component: CertificatesList
  },
  {
    path: '/custom-fields',
    name: 'CustomFields',
    component: CustomFields
  },
  {
    path: '/client-payments',
    name: 'ClientPayments',
    component: ClientPayments
  },
  {
    path: '/employees',
    name: 'Employees',
    component: Employees
  },
  {
    path: '/schedules',
    name: 'Schedules',
    component: SchedulerPage
  },
  /*{
    path: '/schedulesTest',
    name: 'SchedulesTest',
    component: ScheduleSection
  },*/
  {
    path: '/adminAmogen',
    name: 'Admin',
    component: Admin,
    meta: { adminOnly: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterBlock
  },
  {
    path: '/dialogs',
    name: 'Dialogs',
    component: Dialogs
  },
  {
    path: '/messengers',
    name: 'DialogSettings',
    component: DialogSettings
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/billing',
    name: 'Billing',
    component: Billing
  },
  {
    path: '/billing/success',
    name: 'BillingSuccess',
    component: BillingSuccess
  },
  {
    path: '/billing/fail',
    name: 'BillingFail',
    component: BillingFail
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})
router.beforeEach(async (to, from, next) => {
  if (from.name === 'Dialogs' && to.name !== 'Dialogs') {
    store.commit('socket/CLEAR_SELECTED_DIALOG');
  }
  const token = getCookieValue('token')
  // Если данные ещё не загружены и не в процессе загрузки
  if (token) {
    await store.dispatch('auth/getUserInfo')
    await store.dispatch('roles/fetchRoles')
    await store.dispatch('messengers/fetchDialogs')
    // --- CENTRALIZED PERMISSION CHECK ---
    const user = store.state.auth.user
    const perms = user?.permissions

    if (user?.is_admin || perms === '*') return next()

    const normalizePerms = (p) => {
      if (!p) return []
      if (Array.isArray(p)) return p
      if (typeof p === 'object') return Object.values(p).flat()
      return []
    }
    const userPerms = normalizePerms(perms)

    const groupName = routeAccessMap[to.path]
    if (groupName) {
      const groupPerms = permissionGroups[groupName]
      const hasAccess = groupPerms?.some(p => userPerms.includes(p))
      if (!hasAccess) return next('/')
    }

    if (to.meta?.adminOnly && !(user?.is_admin || perms === '*')) {
      return next('/')
    }
    // --- END CENTRALIZED PERMISSION CHECK ---
  }
  next()
})
export default router
